import React from 'react';
import {
    FaHtml5,
    FaCss3Alt,
    FaJs,
    FaReact,
    FaNodeJs,
    FaDatabase,
    FaJava, 
     FaGitAlt,
      FaRobot, 
      FaBrain,
  FaGithub
} from 'react-icons/fa';
import { SiTypescript, SiMongodb, SiMysql,SiSpringboot, SiPostman,SiLeetcode} from 'react-icons/si';
import './Skills.css';

const skills = [
    { icon: <FaHtml5 />, name: 'HTML5' },
    { icon: <FaCss3Alt />, name: 'CSS3' },
    { icon: <FaJs />, name: 'JavaScript' },
    { icon: <SiTypescript />, name: 'TypeScript' },
    { icon: <FaReact />, name: 'React / Next.js' },
    { icon: <FaNodeJs />, name: 'Node.js / Express' },
    { icon: <SiMongodb />, name: 'MongoDB' },
    { icon: <SiMysql />, name: 'SQL / MySQL' },
    { icon: <FaDatabase />, name: 'Database Mgmt' },
    { icon: <FaJava />, name: 'Java' },
    { icon: <SiSpringboot />, name: 'SpringBoot' },
    { icon: <FaGitAlt />, name: 'git' },
    { icon: <FaGithub />, name: 'gitHub' },
    { icon: <SiPostman />, name: 'Postman' }, 
    { icon: <FaRobot />, name: 'GenAI' },
    { icon: <FaBrain />, name: 'Prompt Engineering' },
    { icon: <SiLeetcode />, name: 'DSA / Leetcode' },
];

function Skills() {
    return (
        <section id="skills" className="skills">
            <h2 className="section-title">Tech Stack</h2>

            <div className="skills__marquee">
                <div className="skills__track">
                    {skills.map(({icon, name}, index) => (
                        <div className="skill" key={index}>
                            <span className="skill__icon">{icon}</span>
                            <span className="skill__name">{name}</span>
                        </div>
                    ))}
                </div>
                <div className="skills__track" aria-hidden="true">
                    {skills.map(({icon, name}, index) => (
                        <div className="skill" key={index + '-dup'}>
                            <span className="skill__icon">{icon}</span>
                            <span className="skill__name">{name}</span>
                        </div>
                    ))}
                </div>
            </div>

        </section>
    );
}

export default Skills;
